import { InterestedButton } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/like-button';

interface Props {
  companyId: string;
  className?: string;
}

export function SignalInterestInDataButton(props: Props) {
  return <InterestedButton className={props.className} text="I'm interested" companyId={props.companyId} />;
}
